import EventEmitter from 'events'
import { PermissionDeniedError, WrongCredentialsError } from '../errors'

const NOT_FOUND_STATUS_CODES = [403, 404]

export const ROUTES = {
  CONVERSATION_FIND_ALL: 'conversations.findAll',
  DISTRIBUTION_LIST_FIND: 'distributionLists.find',
  ENTITIES_FIND_ALL: 'entities.findAll',
  ESCALATION: 'escalation',
  GROUP_ADD_MEMBERS: 'group.addMembers',
  GROUP_CREATE: 'group.create',
  GROUP_FIND: 'group.find',
  GROUP_UPDATE: 'group.update',
  MESSAGE_FIND: 'messages.find',
  MESSAGE_FORWARD: 'message.forward',
  MESSAGE_SEND: 'message.send',
  MESSAGE_UPDATE_RECIPIENT_STATUS_MULTI: 'messages.updateRecipientStatusMulti',
  MUTE_FIND_ALL: 'mute.findAll',
  ORGANIZATION_FIND: 'organization.find',
  ORGANIZATION_FIND_ALL_OF_USER: 'organization.findAllOfUser',
  ROLES_CREATE_P2P_GROUP: 'roles.createP2PGroup',
  SEARCH_QUERY: 'search.query',
  USER_FIND: 'user.find',
  USER_FIND_ME: 'user.findMe',
}

export const VERSIONS = {
  VERSION_TWO: 'v2',
  VERSION_FIVE: 'v5',
}

export default class BaseAPI {
  constructor(host, options) {
    Object.assign(this, options)
    this.config = host.config
    this.host = host
    this.httpClient = host.httpClient
  }

  getVersion(route) {
    const { VERSION_TWO, VERSION_FIVE } = VERSIONS
    switch (route) {
      default:
        return {
          version: this.config.condensedReplays ? VERSION_FIVE : VERSION_TWO
        }
    }
  }
}

Object.assign(BaseAPI.prototype, EventEmitter.prototype)

export function recoverFromNotFound({ fallbackValue=null, httpStatusCodes=NOT_FOUND_STATUS_CODES }={}) {
  return function decorator(target, name, descriptor) {
    const fn = descriptor.value
    descriptor.value = async function(...args) {
      try {
        return await fn.call(this, ...args)
      } catch (ex) {
        if (ex.response && httpStatusCodes.includes(ex.response.status)) {
          return fallbackValue
        } else if (ex.code === PermissionDeniedError.CODE && httpStatusCodes.includes(403)) {
          return fallbackValue
        } else if (ex.code === WrongCredentialsError.CODE && httpStatusCodes.includes(401)) {
          return fallbackValue
        } else {
          throw ex
        }
      }
    }
    return descriptor
  }
}
